import { useLocation, useParams, useRouter } from '@tanstack/react-router';
import type { Store } from '../data/store';

export function useStoreSwitch() {
  const router = useRouter();
  const location = useLocation();
  const { storeId } = useParams({ strict: false });

  return (store: Store) => {
    // Preserve the current sub-path when switching stores.
    // e.g., /stores/old-id/orders → /stores/new-id/orders
    if (storeId) {
      router.history.push(location.pathname.replace(`/stores/${storeId}`, `/stores/${store.id}`));
    }
  };
}
